export default __webpack_public_path__ + "static/media/group-8395.6373148a.png";